import * as React from "react";
import AppBar from "@material-ui/core/AppBar/AppBar";
import Toolbar from "@material-ui/core/Toolbar/Toolbar";
import { Content } from "../components/content";
import { Link, RouteComponentProps } from "react-router-dom";
import { RoutePaths } from "../route-paths";
import LinearProgress from "@material-ui/core/LinearProgress/LinearProgress";
import Button from "@material-ui/core/Button/Button";
import LOGO from "../assets/labour_logo_white.svg";
import PageTitles from "./titles";
import { AccountServiceClient } from "../model/autogen/AccountController";
import { ResetPasswordResult } from "../model/autogen/ResetPasswordResult";
import TextField from "@material-ui/core/TextField/TextField";
import { parse } from "query-string";
import { ResetTokenInputModel } from "../model/autogen/ResetTokenInputModel";
import { strIsNullOrEmpty } from "../utils/string";

interface IResetTokenPageProps {

}

interface IResetTokenPageState extends ResetTokenInputModel {
    isSubmitting: boolean;
    resetResult: ResetPasswordResult | undefined;
}

const LoginLink = (props: any) => <Link to={RoutePaths.SignIn} {...props} />

export type ResetTokenPageProps = RouteComponentProps<any> & IResetTokenPageProps;

export class ResetTokenPage extends React.Component<ResetTokenPageProps, IResetTokenPageState> {
    constructor(props: ResetTokenPageProps) {
        super(props);
        this.state = {
            isSubmitting: false,
            userName: "",
            code: "",
            password: "",
            confirmPassword: "",
            resetResult: undefined
        };
    }
    componentDidMount() {
        const { code = "" } = parse(this.props.location.search);
        if (Array.isArray(code)) {
            this.setState({ code: code[0] });
        } else {
            this.setState({ code });
        }
    }
    private onFieldChanged = (e: any) => {
        this.setState({ [e.target.name]: `${e.target.value}` } as any);
    }
    private onSubmit = async (e: any) => {
        const { isSubmitting, resetResult, ...payload } = this.state;
        this.setState({ isSubmitting: true });
        try {
            const result = await AccountServiceClient.resetToken(payload);
            this.setState({ isSubmitting: false, resetResult: result });
        } catch (e) {
            this.setState({ isSubmitting: false, resetResult: undefined });
        }
    }
    private isValidForSubmit = () => {
        return !strIsNullOrEmpty(this.state.password.trim()) && this.state.password == this.state.confirmPassword;
    }
    render(): JSX.Element {
        const { resetResult, isSubmitting, userName, password, confirmPassword } = this.state;
        return <>
            <AppBar position="static" color="primary">
                <Toolbar>
                    <div><img style={{ height: '50px', marginLeft: '-20px' }} className="app-logo-nzl-fern" src={LOGO} /></div>
                </Toolbar>
            </AppBar>
            <Content>
                <h3>{PageTitles.RESET_PASSWORD}</h3>
                {(() => {
                    if (resetResult && resetResult.success) {
                        return <>
                            <p>Your password has been successfully reset</p>
                            <Link to={RoutePaths.SignIn}>Return to Sign-in</Link>
                        </>;
                    } else {
                        if (isSubmitting) {
                            return <LinearProgress />;
                        } else {
                            return <>
                                {resetResult && resetResult.errors && resetResult.errors.length > 0 && <>
                                    <p>Failed to reset your password</p>
                                    <ul>
                                        {resetResult.errors.map((e, i) => <li key={i}>{e}</li>)}
                                    </ul>
                                </>}
                                <TextField fullWidth id="userName" label="Username" value={userName} name="userName" onChange={this.onFieldChanged} margin="normal" />
                                <TextField fullWidth id="password" type="password" label="Password" value={password} name="password" onChange={this.onFieldChanged} margin="normal" />
                                <TextField fullWidth id="confirmPassword" type="password" label="Confirm Password" value={confirmPassword} name="confirmPassword" onChange={this.onFieldChanged} margin="normal" />
                                <Button variant="contained" color="primary" disabled={!this.isValidForSubmit()} onClick={this.onSubmit}>Submit</Button>
                                <Button variant="contained" component={LoginLink}>Return to Sign-in</Button>
                            </>;
                        }
                    }
                })()}
            </Content>
        </>;
    }
}


// WEBPACK FOOTER //
// ./src/pages/reset-token-page.tsx